module.exports = __webpack_public_path__ + "images/surprised.png";